import axios from 'axios'
import {
    POST_LIST_REQUEST,
    POST_LIST_SUCCESS,
    POST_LIST_FAIL,

    POST_DETAILS_REQUEST,
    POST_DETAILS_SUCCESS,
    POST_DETAILS_FAIL,

    POST_DELETE_REQUEST,
    POST_DELETE_SUCCESS,
    POST_DELETE_FAIL,
 
    WORK_LIST_REQUEST,
    WORK_LIST_SUCCESS,
    WORK_LIST_FAIL,
 
    LINK_LIST_REQUEST,
    LINK_LIST_SUCCESS,
    LINK_LIST_FAIL,
 
    OUTER_POST_LIST_REQUEST,
    OUTER_POST_LIST_SUCCESS,
    OUTER_POST_LIST_FAIL,

    OUTER_POST_DETAILS_REQUEST,
    OUTER_POST_DETAILS_SUCCESS,
    OUTER_POST_DETAILS_FAIL,

    OUTER_POST_DELETE_REQUEST,
    OUTER_POST_DELETE_SUCCESS,
    OUTER_POST_DELETE_FAIL,
 
    OUTER_POST_CREATE_REQUEST,
    OUTER_POST_CREATE_SUCCESS,
    OUTER_POST_CREATE_FAIL,
 
    COMMENT_LIST_REQUEST,
    COMMENT_LIST_SUCCESS,
    COMMENT_LIST_FAIL,
 
    COMMENT_CREATE_REQUEST,
    COMMENT_CREATE_SUCCESS,
    COMMENT_CREATE_FAIL,

    COMMENT_LIST_ALL_REQUEST,
    COMMENT_LIST_ALL_SUCCESS,
    COMMENT_LIST_ALL_FAIL,

    COMMENT_DELETE_REQUEST,
    COMMENT_DELETE_SUCCESS,
    COMMENT_DELETE_FAIL,
} from '../constants/mediaConstants'
 
export const listPosts = (keyword = '') => async (dispatch) => {
    try{
        dispatch({type:POST_LIST_REQUEST})
        const { data } = await axios.get(`/api/media/posts/${keyword}`)
        
        

        dispatch({type:POST_LIST_SUCCESS,
        payload:data})
 
    } catch(error) {
        dispatch({type:POST_LIST_FAIL,
        payload: error.response && error.response.data.detail 
        ? error.response.data.detail
        : error.message
    
    })
}
 
}

export const listPostDetails = (id) => async (dispatch) => {
    try {
        dispatch({ type: POST_DETAILS_REQUEST })
        const { data } = await axios.get(`/api/media/post/${id}/`)

        dispatch({
            type: POST_DETAILS_SUCCESS,
            payload: data,
        })

    } catch (error) {
        dispatch({
            type: POST_DETAILS_FAIL,
            payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message
        })
    }
}
 
export const listWorks = async (dispatch) => {
    try{
        dispatch({type:WORK_LIST_REQUEST})
        const { data } = await axios.get('/api/media/works/')
        
        
 
        dispatch({type:WORK_LIST_SUCCESS,
        payload:data})
 
    } catch(error) {
        dispatch({type:WORK_LIST_FAIL,
        payload: error.response && error.response.data.detail 
        ? error.response.data.detail
        : error.message
    
    })
}
 
}
 
export const listLinks = async (dispatch) => {
    try{
        dispatch({type:LINK_LIST_REQUEST})
        const { data } = await axios.get('/api/media/links/')
        
        
 
        dispatch({type:LINK_LIST_SUCCESS,
        payload:data})
 
    } catch(error) {
        dispatch({type:LINK_LIST_FAIL,
        payload: error.response && error.response.data.detail 
        ? error.response.data.detail
        : error.message
    
    })
}
 
}
 
export const listOuterPosts = (keyword = '') => async (dispatch) => {
    try{
        dispatch({type:OUTER_POST_LIST_REQUEST})
        const { data } = await axios.get(`/api/media/outerposts/${keyword}`)
        
        
 
        dispatch({type:OUTER_POST_LIST_SUCCESS,
        payload:data})
 
    } catch(error) {
        dispatch({type:OUTER_POST_LIST_FAIL,
        payload: error.response && error.response.data.detail 
        ? error.response.data.detail
        : error.message
    
    })
}
 
}

export const listOuterPostDetails = (id) => async (dispatch) => {
    try {
        dispatch({ type: OUTER_POST_DETAILS_REQUEST })
        const { data } = await axios.get(`/api/media/outerpost/${id}/`)

        dispatch({
            type: OUTER_POST_DETAILS_SUCCESS,
            payload: data,
        })

    } catch (error) {
        dispatch({
            type: OUTER_POST_DETAILS_FAIL,
            payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message
        })
    }
}
 
 
export const createOuterPost = (formData) => async (dispatch, getState) => {
 
    try{
        dispatch({
            type: OUTER_POST_CREATE_REQUEST
        })
 
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
 
        const {data} = await axios.post(
            `/api/media/create/`, formData, config
        )
        
        dispatch({
            type:OUTER_POST_CREATE_SUCCESS,
            payload: data,
            
        })
 
    }catch(error){ 
        dispatch({
            type: OUTER_POST_CREATE_FAIL,
            payload: error.response && error.response.data.detail 
            ? error.response.data.detail
            : error.message
        })
 
    }
}
 
 
 
 
export const listOuterPostComments = (outerpostId) => async (dispatch) => {
    try {
        dispatch({ type: COMMENT_LIST_REQUEST })
 
        const { data } = await axios.get(`/api/media/outerpost/${outerpostId}/comments/`)
 
        dispatch({
            type: COMMENT_LIST_SUCCESS,
            payload: data,
        })
 
    } catch (error) {
        dispatch({
            type: COMMENT_LIST_FAIL,
            payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message
        })
    }
}
 
 
export const createOuterPostComment = (outerpostId, comment) => async (dispatch, getState) => {
    try {
        dispatch({ type: COMMENT_CREATE_REQUEST })
 
        const {
            userLogin: { userInfo },
        } = getState()
 
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
 
        const { data } = await axios.post(
            `/api/media/outerpost/${outerpostId}/comments/create/`,
            { comment },
            config
        )
 
        dispatch({
            type: COMMENT_CREATE_SUCCESS,
            payload: data,
        })
 
    } catch (error) {
        dispatch({
            type: COMMENT_CREATE_FAIL,
            payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message
        })
    }
}

export const listPostComments = (postId) => async (dispatch) => {
    try {
        dispatch({ type: COMMENT_LIST_REQUEST })

        const { data } = await axios.get(`/api/media/post/${postId}/comments/`)

        dispatch({
            type: COMMENT_LIST_SUCCESS,
            payload: data,
        })

    } catch (error) {
        dispatch({
            type: COMMENT_LIST_FAIL,
            payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message
        })
    }
}


export const createPostComment = (postId, comment) => async (dispatch, getState) => {
    try {
        dispatch({ type: COMMENT_CREATE_REQUEST })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.post(
            `/api/media/post/${postId}/comments/create/`,
            { comment },
            config
        )

        dispatch({
            type: COMMENT_CREATE_SUCCESS,
            payload: data,
        })

    } catch (error) {
        dispatch({
            type: COMMENT_CREATE_FAIL,
            payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message
        })
    }
}


export const listComments = () => async (dispatch, getState) => {
    try {
        dispatch({ type: COMMENT_LIST_ALL_REQUEST })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.get(`/api/media/comments/`, config)

        dispatch({
            type: COMMENT_LIST_ALL_SUCCESS,
            payload: data,
        })

    } catch (error) {
        dispatch({
            type: COMMENT_LIST_ALL_FAIL,
            payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message
        })
    }
}


export const deleteComment = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: COMMENT_DELETE_REQUEST })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        await axios.delete(`/api/media/comments/${id}/delete/`, config)

        dispatch({ type: COMMENT_DELETE_SUCCESS })

    } catch (error) {
        dispatch({
            type: COMMENT_DELETE_FAIL,
            payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message
        })
    }
}


export const deletePost = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: POST_DELETE_REQUEST })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        await axios.delete(`/api/media/post/${id}/delete/`, config)

        dispatch({ type: POST_DELETE_SUCCESS })

    } catch (error) {
        dispatch({
            type: POST_DELETE_FAIL,
            payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message
        })
    }
}


export const deleteOuterPost = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: OUTER_POST_DELETE_REQUEST })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        await axios.delete(`/api/media/outerpost/${id}/delete/`, config)

        dispatch({ type: OUTER_POST_DELETE_SUCCESS })

    } catch (error) {
        dispatch({
            type: OUTER_POST_DELETE_FAIL,
            payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message
        })
    }
}